<template>
  <v-container fluid fill-height v-if="model">
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-clipboard-text</v-icon>Print Package List
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items class="hidden-sm-and-down">
              <v-btn text @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>Back
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <pdf-viewer
            url="orders/printRows"
            :params="{ id: id }"
            :filename="this.filename"
            style="width: 300%"
          ></pdf-viewer>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PdfViewer from "@components/PdfViewer.vue";
export default {
  components: {
    PdfViewer
  },
  data() {
    return {
      id: this.$route.params.id,
      model: null
    };
  },
  computed: {
    filename: function() {
      return "packageList_"+
            this.model.invoiceNumber +
            ".pdf";
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.getOrder(this.id);
    } else {
      this.$route.push("/orders");
    }
  },
  methods: {
    getOrder(id) {
      this.$store
        .dispatch("orders/get", {
          id: id
        })
        .then(data => (this.model = data));
    }
  }
};
</script>

<style></style>
